import { apiRequest } from './httpClient';

// Returns { items, page, page_size, total, total_pages, unread_count }.
export function listNotifications({ page = 1, pageSize = 10 } = {}) {
  const params = new URLSearchParams();
  params.set('page', page);
  params.set('page_size', pageSize);

  return apiRequest(`/api/notifications?${params.toString()}`);
}

export function markNotificationRead(notificationId) {
  return apiRequest(`/api/notifications/${notificationId}/read`, {
    method: 'PATCH',
  });
}

// Returns { updated_count }.
export function markAllNotificationsRead() {
  return apiRequest('/api/notifications/read-all', { method: 'PATCH' });
}

export function deleteNotification(notificationId) {
  return apiRequest(`/api/notifications/${notificationId}`, {
    method: 'DELETE',
  });
}
